import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_keyboard_key = _resolveComponent("keyboard-key")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["keyboard-row", _ctx.rowClass(i)]),
        key: i
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r, (c) => {
          return (_openBlock(), _createBlock(_component_keyboard_key, {
            key: c,
            value: c,
            onAddchar: _ctx.handleKeyDown,
            onBackspace: _ctx.handleDelete
          }, null, 8, ["value", "onAddchar", "onBackspace"]))
        }), 128))
      ], 2))
    }), 128))
  ]))
}